import KeyMirror from 'keymirror';

const LegalIssueTypes = KeyMirror({
    RECEIVE_LEGAL_ISSUES: true,
});

export default LegalIssueTypes;
